import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { searchApi } from './api';

/** Returns the latest `value` but updated only after `delay` ms of stillness. */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/** TanStack Query hook -- slice-307. Fires the search after 250ms of stillness; only
 *  when the query is at least 2 chars. Caches for 30s so re-typing the same query
 *  doesn't round-trip to the BE. */
export function useSearch(query: string) {
  const debounced = useDebounced(query.trim(), 250);
  const enabled = debounced.length >= 2;
  return useQuery({
    queryKey: ['global-search', debounced],
    queryFn: () => searchApi.search(debounced, 5),
    enabled,
    staleTime: 30_000,
  });
}
